package com.xtream.data_kmp.util.exception


//import okhttp3.internal.http2.ConnectionShutdownException
 import com.xtream.data_kmp.AllConst
 import io.ktor.client.network.sockets.SocketTimeoutException
import io.ktor.serialization.JsonConvertException
import kotlinx.io.IOException

class GeneralException : Exception {
    constructor() : super()
    constructor(message: String) : super(message)
    constructor(message: String, cause: Throwable) : super(message, cause)
    constructor(cause: Throwable) : super(cause)
}

class UserNotFoundException : Exception {
    constructor() : super()
    constructor(message: String) : super(message)
}

fun Exception.getErrorMessage(isTimeValid: Boolean = true):String {
    return when (this) {
        is SocketTimeoutException -> {
            AllConst.SOCKET_TIMEOUT_EXCEPTION
        }

      /*  is UnknownHostException -> {
            AllConst.UNKNOWN_HOST_EXCEPTION
        }

        is ConnectionShutdownException -> {
            AllConst.CONNECTION_SHUTDOWN_EXCEPTION
        }

        is ConnectException -> {
            AllConst.CONNECTION_EXCEPTION

        }

        is SSLHandshakeException -> {
            if (isTimeValid) {
                AllConst.SSL_HANDSHAKE_EXCEPTION
            } else
                AllConst.SYSTEM_TIME_INVALID
        }*/
        is IOException -> {
            AllConst.IO_EXCEPTION
        }

        is UserNotFoundException -> {
            AllConst.USER_NOT_FOUND_EXCEPTION
        }

        is JsonConvertException -> {
            AllConst.JSON_CONVERT_EXCEPTION

        }

        is GeneralException -> {
            this.message.toString()
        }


        else -> {
            this.message.toString()//AllConst.UNKNOWN_EXCEPTION
        }
    }
}